// extracted by mini-css-extract-plugin
export default {"root":"gift_card_page_root__pt3K8","tab_root":"gift_card_page_tab_root__HBg9-","create_button":"gift_card_page_create_button__MFv47"};